import ToolEntryButton from '~/components/toolbar/shared/ToolEntryButton';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';

/**
 * Arms the free rotation: a drag on a tile turns the plane views of that
 * tile's image together.
 */
export default function RotateViewTool() {
    const { rotateView } = useViewingToolEntries();

    return <ToolEntryButton entry={rotateView} />;
}
